import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import "./BookingPage.css";

function BookingPage() {
  const [formData, setFormData] = useState({
    name: "",
    country: "",
    phone: "",
    pickupAddress: "",
    destination: "",
    vehicle: "camry",
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // Save the form data to Firestore
      const docRef = await addDoc(collection(db, "bookings"), {
        ...formData,
        timestamp: new Date(),
        read: false,
      });

      console.log("Document written with ID: ", docRef.id);
      alert("Booking request successfully submitted!");

      // Reset form
      setFormData({
        name: "",
        country: "",
        phone: "",
        pickupAddress: "",
        destination: "",
        vehicle: "camry",
      });
    } catch (error) {
      console.error("Error adding document: ", error);
      alert(
        "An error occurred while submitting the booking. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="booking-page">
      <h1>Book Your Taxi</h1>
      <form onSubmit={handleSubmit} className="booking-form">
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="country"
          placeholder="Country"
          value={formData.country}
          onChange={handleChange}
          required
        />
        <input
          type="tel"
          name="phone"
          placeholder="Phone Number"
          value={formData.phone}
          onChange={handleChange}
          pattern="[0-9]{10,15}"
          title="Enter a valid phone number"
          required
        />
        <input
          type="text"
          name="pickupAddress"
          placeholder="Pickup Address"
          value={formData.pickupAddress}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="destination"
          placeholder="Destination"
          value={formData.destination}
          onChange={handleChange}
          required
        />
        <div className="vehicle-dropdown">
          <label htmlFor="vehicle">Select Vehicle:</label>
          <select
            id="vehicle"
            name="vehicle"
            value={formData.vehicle}
            onChange={handleChange}
          >
            <option value="camry">CAMRY</option>
            <option value="hiace">HIACE</option>
            <option value="gmc-yukon">GMC YUKON</option>
            <option value="h1-hundai">H1 HUNDAI</option>
            <option value="coaster">COASTER</option>
            <option value="staria">STARIA</option>
          </select>
        </div>
        <button type="submit" disabled={isLoading}>
          {isLoading ? "Submitting..." : "Book Taxi"}
        </button>
      </form>
    </div>
  );
}

export default BookingPage;
